import { Bolt } from '@styled-icons/material';
import { Button, Text } from '@typedream/ui';
import mixpanel from 'mixpanel-browser';
import { useContext } from 'react';

import { EVENT } from '../../analytics';
import { useSpaceAndPageIDFromRouter } from '../../data/space/hooks';
import { useGetSpaceQuery } from '../../store';
import { STEP_MAP } from '../CustomDomainPopup/constants';
import {
  CustomDomainActiveDispatchContext,
  CustomDomainPopupDispatchContext,
} from '../CustomDomainPopup/context';
import styles from './PublishButton.module.css';
import PublishedLinks from './PublishedLinks';
import PublishedPages from './PublishedPages';

function PublishedSection({ currentPageOnly }: { currentPageOnly: boolean }) {
  const [spaceID] = useSpaceAndPageIDFromRouter();
  const { data: space } = useGetSpaceQuery([spaceID]);
  const setactive = useContext(CustomDomainActiveDispatchContext);
  const setcustomDomainPopupOpen = useContext(CustomDomainPopupDispatchContext);
  const onClick = () => {
    mixpanel.track(EVENT.CLICK_ADD_CUSTOM_DOMAIN_PUBLISH_DROPDOWN);
    setactive(STEP_MAP.add_custom_domain.key);
    setcustomDomainPopupOpen(true);
  };

  return (
    <div className={styles.content}>
      <div className="p-2 flex justify-start items-center">
        <div className="p-2 text-3xl tracking-tighter">🎉</div>
        <div className="p-2 text-xl tracking-tight">Published</div>
      </div>

      <PublishedPages showTitle={false} currentPageOnly={currentPageOnly} />
      <PublishedLinks published />

      {!space?.custom_domain && (
        <div className="flex flex-col flex-1 gap-2 py-2 px-[18px]">
          <Text size="xs" variant="secondary">
            Next step:
          </Text>
          <Button className="rounded" onClick={onClick} leftIcon={<Bolt size={20} />}>
            Add custom domain
          </Button>
        </div>
      )}
    </div>
  );
}

export default PublishedSection;
